import React from "react";
import IocListManager from "./IocListManager";

export default function BlacklistedIocs() {
  return (
    <IocListManager
      apiPath="/api/admin/blacklist"
      variant="danger"
      title="Blacklisted IoCs"
      subtitle="Known-bad senders, domains, IPs, hostnames, and URLs. An active match forces a Malicious verdict during analysis, overriding other signals."
      valuePlaceholder="e.g. evil.com or 203.0.113.9 or attacker@bad.com"
      notesPlaceholder="Why is this blacklisted?"
      emptyText="No blacklist entries yet. Add the first one above."
      forbiddenText="This section is only available to administrators and contributors."
    />
  );
}
